import React, { useState } from 'react';
import { Modal } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { certPowershell } from './certPowershell';

// Značky použité v preložených textoch návodu (global.json, kľúče certHelp* / spHelp*).
const TAGS = { strong: <strong />, em: <em />, code: <code />, note: <span className="sp-help-note" /> };

// Sites.Selected — pridelenie prístupu ku konkrétnej lokalite (PnP PowerShell).
const grantPowershell = (siteUrl) => `Connect-PnPOnline -Url "${siteUrl}" -Interactive
Grant-PnPAzureADAppSitePermission -AppId "<client-id>" -DisplayName "SharePoint Sync" -Site "${siteUrl}" -Permissions Read`;

const CertHelpModal = ({ open, onClose }) => {
  const [t] = useTranslation('global');
  const [copied, setCopied] = useState(false);
  const tr = (key) => <Trans t={t} i18nKey={key} components={TAGS} />;
  const certPs = certPowershell(t('spHelpPsPassword'));

  const copyPs = async () => {
    try {
      await navigator.clipboard.writeText(certPs);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch (e) { /* clipboard nedostupný — ignoruj */ }
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="sp-cert-help-title">
      <div className="env-modal sp-help-modal">
        <div className="new-env-title">
          <h1 id="sp-cert-help-title">{t('certHelpTitle')}</h1>
        </div>

        <div className="sp-help-body">
          <p className="sp-help-intro">{tr('certHelpIntro')}</p>

          <ol className="sp-help-steps">
            <li>
              <strong>{t('spHelpRegisterTitle')}</strong>
              <span>{tr('certHelpRegisterText1')}</span>
              <span>{tr('certHelpRegisterText2')}</span>
              <span>{tr('certHelpRegisterText3')}</span>
            </li>

            <li>
              <strong>{t('certHelpCertTitle')}</strong>
              <span>{tr('certHelpCertText')}</span>
              <span className="sp-help-note">{tr('spHelpSameApp')}</span>

              <details className="sp-help-detail">
                <summary><strong>{t('spHelpManualPs')}</strong><span className="sp-help-tag simple">{t('spHelpAlternative')}</span></summary>
                <div className="sp-help-detail-body">
                  <p>{tr('spHelpPsIntro')}</p>
                  <div className="sp-help-code-wrap">
                    <button type="button" className="sp-help-copy" onClick={copyPs}>
                      <span className="material-symbols-outlined">{copied ? 'check' : 'content_copy'}</span>
                      {copied ? t('copied') : t('copy')}
                    </button>
                    <pre className="sp-help-code">{certPs}</pre>
                  </div>
                  <div className="sp-help-callout">
                    <div><span className="sp-file-tag cer">.cer</span> {tr('spHelpCerFile')}</div>
                    <div><span className="sp-file-tag pfx">.pfx</span> {tr('spHelpPfxFile')}</div>
                  </div>
                </div>
              </details>
            </li>

            <li>
              <strong>{t('spHelpUploadCertTitle')}</strong>
              <span>{tr('certHelpUploadText')}</span>
            </li>

            <li>
              <strong>{t('certHelpPermTitle')}</strong>
              <span>{tr('certHelpPermText')}</span>

              <details className="sp-help-detail">
                <summary><strong>{t('certHelpOptionA')}</strong><span className="sp-help-tag simple">{t('certHelpSimpler')}</span></summary>
                <div className="sp-help-detail-body">
                  <p>{tr('certHelpOptionAText')}</p>
                  <p className="sp-help-note">{tr('certHelpOptionAWarn')}</p>
                </div>
              </details>

              <details className="sp-help-detail">
                <summary><strong>{t('certHelpOptionB')}</strong><span className="sp-help-tag safe">{t('certHelpSafer')}</span></summary>
                <div className="sp-help-detail-body">
                  <p>{tr('certHelpOptionBText')}</p>
                  <p>{tr('certHelpOptionBStep1')}</p>
                  <p>{tr('certHelpOptionBStep2')}</p>
                  <pre className="sp-help-code">{grantPowershell(t('spSiteUrlExample'))}</pre>
                  <p className="sp-help-note">{t('certHelpOptionBNote')}</p>
                </div>
              </details>

              <div className="sp-help-warn">
                <span className="material-symbols-outlined">warning</span>
                <span>{tr('certHelpPermWarn')}</span>
              </div>
            </li>

            <li>
              <strong>{t('certHelpFillTitle')}</strong>
              <ul className="sp-help-fields">
                <li>{tr('certHelpFillSite')}</li>
                <li><strong>Application (client) ID</strong> — {t('spHelpFromStep1')}</li>
                <li><strong>Directory (tenant) ID</strong> — {t('spHelpFromStep1')}</li>
                <li>{tr('certHelpFillCert')}</li>
              </ul>
            </li>

            <li>
              <strong>{t('spHelpTestTitle')}</strong>
              <span>{tr('spHelpTestText')}</span>
              <span className="sp-help-note">{tr('certHelpTestNote')}</span>
            </li>
          </ol>
        </div>

        <div className="sp-modal-footer">
          <button type="button" className="submit-button" onClick={onClose}>{t('close')}</button>
        </div>
      </div>
    </Modal>
  );
};

export default CertHelpModal;
